import React from "react";
import  { useState, useEffect } from 'react';
import './classes/SoccerAgency.css';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import AgencySidebar from "./AgencySidebar";

const SoccerAgency = () => {

    // const navigate = useNavigate();
    // const app_url = configData.APP_URL;
   const [isLoading, setIsLoading] = useState(true);
   const [soccerDirectors, setsoccerDirectors] = useState([]);
   const [blogData, setBlogData] = useState([]);
   const app_url = configData.APP_URL;

    useEffect(() => {

         const soccerDirectors = [   
             {
                name: "Maikel Tsuji",
                image: "/basic/web/images/agent/picture-2792-1485296250.jpg",
                link: "/agent/maikel-tsuji-soccer",
                bio: ["FIFA Agent","Former Professional Soccer Player"]
            },          
            {
                name: "Dr. Lynn Lashbrook",
                image: "/basic/web/images/agent/picture-2742-1696447573.jpg",
                link: "/agent/lynn-lashbrook",
                bio: ["SMWW Agency President & Founder"]
            },
            
            
        ];
        setsoccerDirectors(soccerDirectors);        
    },[]);

    useEffect(() => {
        Promise.all([
          getagencynewslist() 
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);

  async function getagencynewslist() {
    try {
      const response = await fetch(
        app_url+'smwwblog/getagencynewslist',
        {
          method: "GET",
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      const responsedata = await response.json();
      if(responsedata.data.msg === "Success") {
        setBlogData(responsedata.data.result);
      }
    } catch (error) {
      console.error(error);
    }finally {
      // Set loading to false after fetch completes (success or error)
    }
  }

    // const handleClick = (continent) => {
    //     navigate('/continents/'+continent+'/scouts');
    // };
    
    
    return (
        <>
       {isLoading ? (
            <Loading />
        ) : ( 
            <div id="soccer-agency-banner-main">
            <div className="sports_agent_career_banner jobs_in_sports_banner" style={{"display":"inline-block","width":"100%"}}>
            <img className="medium_sized_image desktop-baseball-banner-img ban-img" src="/basic/web/images/agent/soccer_agency.png" style={{"width":"100%"}}/>
            <img className="medium_sized_image desktop-soccer-banner-img mobile_ban_img" src="/basic/web/images/agent/mobile_soccer.png" style={{"width":"100%"}}/>
          <div
            className="img_descp"
            style={{
                color: "white",
                position: "absolute",
                marginTop: "-21%",
                marginLeft: "45%",
                textShadow: "2px 2px 8px black, 0 0 25px black",
                filter: "drop-shadow(2px 2px 0px black)"
            }}
            >
            <h1
                className="h1_img_descp"
                style={{
                fontSize: "3.2vw",
                fontWeight: "bold"
                }}
            >
                SMWW Soccer Agency
            </h1>

            <h2
                className="h2_img_descp"
                style={{
                fontSize: "1.85vw"
                }}
            >
                An extensive network of Agent Advisors <br />
                 representing soccer players throughout <br />
                  the world.
            </h2>
            </div>

            </div>
  
            <div id="main" className="soccer-agency-main">
                <Helmet><title>SMWW Soccer Agency</title></Helmet>
                <div className="left soccer-agency-left">
                    <div className="view-content">
                    <h2>Soccer Directors</h2>
                    <div className="item-list mentors-wrapper">
                    <ul>
                        {/* Desktop Wrapper */}
                        <div className="des_sports_wrapper">
                        {soccerDirectors.map((director, index) => (
                            <li
                            key={index}
                            className={`views-row views-row-${index + 1} ${
                                index % 2 === 0 ? "views-row-odd" : "views-row-even"
                            } ${index === 0 ? "views-row-first" : ""} ${
                                index === soccerDirectors.length - 1 ? "views-row-last" : ""
                            }`}
                            >
                            <div className="views-field views-field-picture">
                                <div className="field-content">
                                <img
                                    className="lazyloaded"
                                    width="193"
                                    height="158"
                                    src={director.image}
                                    alt={director.name}
                                />
                                </div>
                            </div>

                            <div className="views-field views-field-field-last-name">
                                <div className="field-content">
                                <a href={director.link}>{director.name}</a>
                                </div>
                            </div>

                            <div className="views-field views-field-field-mentor-biography text">
                                <div className="field-content">
                                <ul>
                                    {director.bio.map((item, i) => (
                                    <li key={i}>{item}</li>
                                    ))}
                                </ul>
                                </div>
                            </div>
                            </li>
                        ))}
                        </div>

                        {/* Mobile Wrapper */}
                        <div className="mob_sports_wrapper">
                        {soccerDirectors.map((director, index) => (
                            <div
                            key={index}
                            className={index % 2 === 0 
                                ? "mob_sports_wrapper_odd" 
                                : "mob_sports_wrapper_even"}
                            >
                            <li
                                className={`sports_directors_li views-row views-row-${index + 1} ${
                                index % 2 === 0 ? "views-row-odd" : "views-row-even"
                                } ${index === 0 ? "views-row-first" : ""} ${
                                index === soccerDirectors.length - 1 ? "views-row-last" : ""
                                }`}
                            >
                                <div className="views-field views-field-picture">
                                <div className="field-content">
                                    <img
                                    className="lazyloaded"
                                    width="193"
                                    height="158"
                                    src={director.image}
                                    alt={director.name}
                                    />
                                </div>
                                </div>

                                <div className="views-field views-field-field-last-name">
                                <div className="field-content">
                                    <a href={director.link}>{director.name}</a>
                                </div>
                                </div>

                                <div className="views-field views-field-field-mentor-biography text">
                                <div className="field-content">
                                    <ul>
                                    {director.bio.map((item, i) => (
                                        <li key={i}>{item}</li>
                                    ))}
                                    </ul>
                                </div>
                                </div>
                            </li>
                            </div>
                        ))}
                        </div>
                    </ul>
                    </div>

                </div>
                </div>
                <div className="center left-center">
                   <div className="soccer-agency-center">
                        <h1>SMWW Soccer Agency</h1>
                        <h3><span style={{"color":"#003c7d"}}><strong><em>Go Global or Go Home</em></strong></span></h3>
                        <p><strong>Sports Management Worldwide Soccer Agency</strong>&nbsp;is an international full-service soccer&nbsp;agency with an extensive network of Agent Advisors serving soccer players&nbsp;throughout the world.</p>
                        <h3><span style={{"color":"#003c7d"}}><strong><em>The Best of Both Worlds</em></strong></span></h3>
                        <p><strong>Sports Management Worldwide&nbsp;Soccer Agency</strong>&nbsp;provides a&nbsp;<em>"two-for-one"</em>&nbsp;Agent approach. SMWW partners a personalized, enthusiastic, passionate, newly trained Agent Advisor with a highly experienced, certified veteran Agent.&nbsp;</p>
                        <h3><span style={{"color":"#003c7d"}}><em><strong>Diamonds in the rough</strong></em></span></h3>
                        <p><strong>Sports Management Worldwide Soccer Agency</strong> is well known for finding talented soccer players&nbsp;with exceptional potential and quality characteristics.</p>
                        <h3><strong><span style={{"color":"#003c7d"}}><em>Getting things right on &amp; off the pitch&nbsp;is vital to a long successful&nbsp;career</em></span></strong></h3>
                        <p><strong>&nbsp;Sports Management Worldwide Soccer Agency</strong> has an unmatched level of combined&nbsp;experience with contract negotiation, career strategy,&nbsp;endorsements, sponsorship, personal brand,&nbsp;and player&nbsp;development.</p>
                        <h3><span style={{"color":"#003c7d"}}><em><strong>Exponentially&nbsp;increases the advantages for our clients</strong></em></span></h3>
                        <p><strong>Sports Management Worldwide Soccer Agency</strong> is backed by the the global leader in sports business education. The&nbsp;knowledge &amp; experience of our vast resources, combined with collective global contacts, <u><em>exponentially</em></u>&nbsp;creates&nbsp;massive&nbsp;advantages for our clients.&nbsp;</p>
                                        
                        <div style={{
                            listStyle: "none",
                            boxSizing: "border-box",
                            margin: 0,
                            padding: 0,
                            border: 0,
                            fontFamily: "sans-serif",
                            fontSize: "14px",
                            backgroundColor: "rgb(246, 245, 245)",
                            color: "rgb(255, 0, 0)"
                            }}>
                            <em style={{
                                listStyle: "none",
                                boxSizing: "border-box",
                                margin: 0,
                                padding: 0,
                                border: 0,
                                lineHeight: "18px"
                            }}>
                              If you are a soccer player looking for representation, we look forward to discussing your career and finding options available to you. Please complete our

                            </em>
                            <span style={{color: "rgb(0, 0, 0)"}}> </span>
                            <a href="/lookingforagent.php" style={{
                                listStyle: "none",
                                boxSizing: "border-box",
                                margin: 0,
                                padding: 0,
                                border: 0,
                                color: "rgb(33, 61, 134)",
                                fontSize: "14px",
                                fontFamily: "inherit",
                                fontStyle: "inherit",
                                backgroundColor: "rgb(246, 245, 245)",
                                outline: 0,
                                verticalAlign: "baseline"
                            }}>
                                online application
                            </a>
                            <span style={{color: "rgb(0, 0, 0)"}}>. </span>
                            </div>
                           <p>
                        <a
                            className="reddbtnn"
                            href="/agents/soccer"
                            style={{
                            width: '80%',
                            textAlign: 'center',
                            backgroundImage: 'linear-gradient(rgb(254, 0, 0) 0%, rgb(182, 0, 0) 100%)',
                            backgroundColor: 'rgb(255, 255, 255)',
                            }}
                        >
                            VIEW OUR SOCCER AGENTS
                        </a>
                        </p>

                    </div>
                </div>
                <div className="right agent-domain-sports">
                  <AgencySidebar/>
                  <h2>SMWW Sports Agency News</h2>
                  <div className="agency_blog">
                    <ul className="list-unstyled mb-0">
                      {blogData.slice(0, 5).map((post, index) => (
                        <div key={index}>
                          <li
                            style={{
                              listStyleType: "none",
                              listStyle: "outside none"
                            }}
                          >
                            <a href={post.link}>
                              <img src={post.image} alt={post.title} />
                            </a>

                            <p className="stwwt-post-title">
                              <a className="post-para" href={post.link}>
                                {post.title}
                              </a>
                              <br />
                              <a href={post.link}>
                                <span className="button mr-1 arrow">Read Article</span>
                              </a>
                            </p>
                          </li>

                          {/* Separator */}
                          {index < blogData.slice(0, 5).length - 1 && <li className="sepline">&nbsp;</li>}
                        </div>
                      ))}
                    </ul>
                  </div>

                </div>
            </div>
            </div>
        )}
        </>
    );
};
export default SoccerAgency;